module.exports = __webpack_public_path__ + "static/working4-97177cfcc4cf7ed402f351e79f42f65d.png";